<template>
  <div id="departments">
    <div class="task">
      <div class="task-left">
        <div class="task-header">
          <ul class="task-header-left">
            <li v-for="(item, index) in subClsLists" :key="item.index"
              :class="{ taskHeaderNavClick: index == navListNum }" @click="navClick(index)" :title="item.name">
              {{ item.name }}</li>
            <li v-if="headerTabMoreBtn" :class="{ taskHeaderNavClick: navListNum == 6 }">
              <el-dropdown @command="moreListsClick" :hide-on-click="false">
                <span class="el-dropdown-link">
                  {{ $t('message.table.more') }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in headerMoreLists" :key="index" :command="item.value"
                    :class="{ 'selected': status == item.value }">{{ item.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>

          <ul class="task-header-right">
            <div class="task-header-right-radio" @change="typeClick">
              <el-radio-group v-model="radio1">
                <el-radio-button :label="$t('message.button.list')"></el-radio-button>
                <el-radio-button :label="$t('message.button.state')"></el-radio-button>
                <el-radio-button :disabled="radioType" :label="$t('message.button.type')"></el-radio-button>
                <el-radio-button :label="$t('message.button.members')"></el-radio-button>
              </el-radio-group>
            </div>
          </ul>
        </div>

        <div class="task-content">
          <div class="task-content-select">
            <div class="task-content-select1">
              <el-select v-model="searchValue.searchMapVo.rootProjectIds"
                style="width:180px;color: #f5f6f8; margin-bottom: 4px;" size="small" multiple collapse-tags
                :placeholder="$t('message.placeholder.project')" clearable
                @change="((val) => { multipleLoadTable(val, 0) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select1list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.projectStatusIds"
                style="width:180px;color: #f5f6f8;margin-left: 10px;margin-bottom: 4px;" collapse-tags multiple
                size="small" :disabled="projectStatusId" :placeholder="$t('message.placeholder.state')"
                @change="((val) => { multipleLoadTable(val, 1) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select2list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.projectStatusTypes"
                style="width:180px;color: #f5f6f8;margin-left: 10px;margin-bottom: 4px;" collapse-tags multiple
                size="small" :disabled="projectStatusType" :placeholder="$t('message.placeholder.stateType')"
                @change="((val) => { multipleLoadTable(val, 2) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select5list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.overdueTypeId"
                style="width:120px;color: #f5f6f8;margin-left: 10px;margin-bottom: 4px;" size="small"
                :placeholder="$t('message.placeholder.lateType')" clearable @change="loadTable">
                <el-option v-for="item in select4list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <div style="width:280px;color: #f5f6f8;margin-left: 10px;display: inline-block;">
                <el-input :placeholder="$t('message.placeholder.input')" v-model="searchValue.searchMapVo.val"
                  style="width: 220px;" size="small" clearable>
                </el-input>
                <el-button icon="el-icon-search" size="small" @click="loadTable">
                </el-button>
              </div>

              <br>

              <el-select v-model="searchValue.searchMapVo.principalIds"
                style="width:180px;color: #f5f6f8;margin-bottom: 4px;" collapse-tags multiple size="small"
                :placeholder="tipMap[1051011]" @change="((val) => { multipleLoadTable(val, 3) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select3list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.projectManagerIds"
                style="width:180px;color: #f5f6f8; margin-left: 10px;margin-bottom: 4px;" collapse-tags multiple
                size="small" :placeholder="tipMap[1051010]" @change="((val) => { multipleLoadTable(val, 6) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select6list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.executorIds"
                style="width:180px;color: #f5f6f8; margin-left: 10px;margin-bottom: 4px;" collapse-tags multiple
                size="small" :placeholder="tipMap[1055001]" @change="((val) => { multipleLoadTable(val, 7) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select7list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="searchValue.searchMapVo.observerIds"
                style="width:180px;color: #f5f6f8; margin-left: 10px;margin-bottom: 4px;" collapse-tags multiple
                size="small" :placeholder="tipMap[1051020]" @change="((val) => { multipleLoadTable(val, 8) })">
                <el-option class="option-cancel" :label="$t('message.table.cancelAll')" value="cancleAll"></el-option>
                <el-option v-for="item in select8list" :key="item.value" :label="item.label" :title="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="task-content-table" v-if="listsShow">
            <vxe-grid ref="xGrid" :scroll-y="{ gt: 80 }" v-bind="gridOptions" @cell-click="rowClick"
              :loading="taskLoading">
            </vxe-grid>
          </div>

          <div class="task-content-table2" v-if="!listsShow">
            <ul class="table2Lists">
              <li v-for="(item, index) in groupProjectVoList" :key="index">
                <div class="table2List-header">
                  <div class="table2List-header-inner">
                    <i class="el-icon-edit-outline" style="color: rgb(140, 146, 164);position:relative;top: 2px;"></i>
                    <span class="table2List-header-inner-name">{{ item.title }}</span>
                    <span class="table2List-header-inner-number">{{ item.number }}</span>
                    <span class="table2List-header-inner-time1" :class="item.isClick == 0 ? 'sort-click' : ''"
                      @click="sortListEndTime(index)">结束时间<i
                        :class="thisEndIndex === index ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i></span>
                    <span class="table2List-header-inner-time" :class="item.isClick == 1 ? 'sort-click' : ''"
                      @click="sortListstartTime(index)">起始时间<i
                        :class="thisStartIndex === index ? 'el-icon-sort-down' : 'el-icon-sort-up'"></i></span>
                  </div>
                </div>

                <div v-if="item.dataList.length == 0"
                  style="font-size: 14px; color: #909aaa;text-align: center;padding: 1rem 0;">这里没有任务</div>
                <div class="table2List-body">
                  <div class="table2List-body-card" v-for="(contentItem, index2) in item.dataList" :key="index2"
                    :class="{ isOverdue: contentItem.rateDate < 0, isOver: contentItem.statusType == 3, isRate: contentItem.rateDate < 3 && contentItem.rateDate > -1 && contentItem.statusType != 3 }"
                    @click="table2RowClick(index, index2)">
                    <div class="table2List-body-card-name" :class="contentItem.isLeaf == 1 ? 'el-icon-s-help' : ''"
                      @click="table2RowClick(index, index2)"><span v-if="contentItem.displayOrder !== null"
                        style="color: #E6A23C;">({{ contentItem.displayOrder }})</span> {{ contentItem.name }}</div>
                    <div class="table2List-body-card-type">
                      <span class="table2List-body-card-type-subCls">{{ contentItem.subclassName }}</span>
                      <span class="table-rate"
                        v-if="contentItem.rateDate < 3 && contentItem.rateDate > -1 && contentItem.statusType != 3">即将逾期</span>
                      <span class="table2List-body-card-type-schOverdueTime"
                        :class="{ red: contentItem.schOverdueTime > 0, green: contentItem.schOverdueTime < 0 }"
                        v-if="contentItem.schOverdueTime">{{ contentItem.schOverdueTime > 0 ?
                          '逾期' : '提前' }}{{ Math.abs(contentItem.schOverdueTime) }}天</span>
                      <span class="table2List-body-card-type-schOverdueTime-over"
                        v-if="contentItem.statusType == 3">已完成</span>
                    </div>
                    <div class="table2List-body-card-date">
                      <span class="table2List-body-card-date-time">
                        <i class="el-icon-time"></i>
                        {{ contentItem.schEndDate }}
                      </span>
                      <span class="table2List-body-card-date-time" :title="contentItem.rootName">
                        {{ $t("message.title.rootName") }} : <span v-if="contentItem.rootName !== ''">{{
                          contentItem.rootName }}</span><span v-else>{{
                            $t("message.table.none") }}</span>
                      </span>
                      <span class="table2List-body-card-date-time" :title="contentItem.parentName">
                        {{ $t("message.title.firstLayerProjectName") }} : <span
                          v-if="contentItem.firstLayerProjectName !== ''">{{ contentItem.firstLayerProjectName
                          }}</span><span v-else>{{ $t("message.table.none") }}</span>
                      </span>
                      <span class="table2List-body-card-date-time" :title="contentItem.parentName">
                        {{ $t("message.title.parentName") }} : <span v-if="contentItem.parentName !== ''">{{
                          contentItem.parentName }}</span><span v-else>{{
                            $t("message.table.none") }}</span>
                      </span>
                      <!-- <span class="table2List-body-card-date-user" :title="contentItem.loginId">
                        <i class="el-icon-user-solid"></i>
                        {{contentItem.loginId}}
                      </span> -->
                    </div>
                    <div class="table2List-body-card-date-user" :title="contentItem.projectManager">
                      <i class="el-icon-user-solid"></i>
                      {{ tipMap[1051010] }}：<span v-if="contentItem.projectManager !== null">{{
                        contentItem.projectManager }}</span><span v-else>{{
                          $t("message.table.none") }}</span>
                    </div>
                    <div class="table2List-body-card-date-user" :title="contentItem.principal">
                      <i class="el-icon-user-solid"></i>
                      {{ tipMap[1051011] }}：<span v-if="contentItem.principal !== null">{{ contentItem.principal
                        }}</span><span v-else>{{
                          $t("message.table.none") }}</span>
                    </div>
                    <div class="table2List-body-card-date-user" :title="contentItem.executors">
                      <i class="el-icon-user-solid"></i>
                      {{ tipMap[1055001] }}：<span v-if="contentItem.executors !== null">{{ contentItem.executors
                        }}</span><span v-else>{{
                          $t("message.table.none") }}</span>
                    </div>
                    <div class="table2List-body-card-date-user" :title="contentItem.observer">
                      <i class="el-icon-user-solid"></i>
                      {{ tipMap[1051020] }}：<span v-if="contentItem.observer !== null">{{ contentItem.observer
                        }}</span><span v-else>{{
                          $t("message.table.none") }}</span>
                    </div>

                  </div>

                  <!-- <div class="table2List-body-card">
                    <div class="table2List-body-card-name">新手任务 - 创建第一个仓库新手任务</div>
                    <div class="table2List-body-card-type">
                      <span class="table2List-body-card-type-subCls">任务</span>
                      <span class="table2List-body-card-type-schOverdueTime">已逾期</span>
                    </div>
                    <div class="table2List-body-card-date">
                      <span class="table2List-body-card-date-time">
                        <i class="el-icon-time"></i>
                        2013-3-21
                      </span>
                      <span class="table2List-body-card-date-user">
                        <i class="el-icon-user-solid"></i>
                        Jeep
                      </span>
                    </div>
                  </div> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="task-right">
        <Right></Right>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Right from './component/right.vue'
export default {
  name: 'myAgent',
  components: {
    Right
  },
  data() {
    return {
      projectStatusId: false,
      projectStatusType: false,

      sortTime: false,
      sortTime1: false,
      thisStartIndex: null,
      thisEndIndex: null,

      select1: "",
      select1list: [],
      select2: "",
      select2list: [],
      oldSelect2list: [],
      select3: [],
      select3list: [],
      select4: "",
      select4list: [],
      select5: "",
      select5list: [],
      tipMap: {},

      select6: "",
      select6list: [],
      select7: "",
      select7list: [],
      select8: "",
      select8list: [],

      listsShow: false,
      groupProjectVoList: [],
      oldGroupProjectVoList: [],
      newGroupProjectVoList: [],

      status: '2',

      searchValue: {
        searchMapVo: {
          overdueTypeId: "",
          rootProjectIds: [],
          principalIds: [],
          executorIds: [],
          observerIds: [],
          projectManagerIds: [],
          projectStatusIds: [],
          projectStatusTypes: [],
          val: "",
        },
        searchType: 2,
        subClassId: this.Constants.ppmTaskSubClassId,
      },

      value: '',
      radio1: this.$t('message.button.state'),
      radioType: false,
      navListNum: 4,
      subClsLists: [{
        name: this.$t('message.table.all'),
        value: 0,
      }],
      headerMoreLists: [],
      headerTabMoreBtn: false,

      gridOptions: {
        keepSource: true,
        resizable: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "640",
        size: "small",
        columns: [{ type: 'seq', width: 50 },
        { field: 'name', title: this.$t('message.title.proName'), width: 460, showHeaderOverflow: true },
        { field: 'subclassName', title: this.$t('message.title.type'), showHeaderOverflow: true },
        { field: 'schStartDate', title: this.$t('message.title.startTime'), showHeaderOverflow: true },
        { field: 'schEndDate', title: this.$t('message.title.endTime'), showHeaderOverflow: true },
        { field: 'createDate', title: this.$t('message.title.createTime'), showHeaderOverflow: true },
        { field: 'schOverdueTime', title: this.$t('message.title.overdueDays'), showHeaderOverflow: true },
        { field: 'principal', title: this.$t('message.title.principal'), showOverflow: true }],
        data: [],
        sortConfig: {
          trigger: "cell",
        },
      },
      taskLoading: false,
    }
  },
  methods: {
    sortListstartTime(val) {//起始时间排序
      this.groupProjectVoList[val].isClick = 1;
      if (this.thisStartIndex == null) {//取初始值的倒序
        this.thisStartIndex = val;
        let newData = this.deepClone(this.oldGroupProjectVoList[val]);
        this.groupProjectVoList[val].dataList = newData.dataList.reverse();
      } else {
        this.thisStartIndex = null;//取初始值
        let newData = this.deepClone(this.oldGroupProjectVoList[val]);
        this.groupProjectVoList[val].dataList = newData.dataList;
      };
    },
    sortListEndTime(val) {//结束时间排序
      this.groupProjectVoList[val].isClick = 0;
      if (this.thisEndIndex == null) {//取初始值的倒序
        this.thisEndIndex = val;
        console.log("1");
        if (this.newGroupProjectVoList[val]) {//如果已经进行过排序，取已经存储的新值
          let arr = this.deepClone(this.newGroupProjectVoList[val]);
          this.groupProjectVoList[val].dataList = arr.dataList;
          console.log("2");
        } else {//第一次倒序排序，保存倒序的值
          let arr = this.deepClone(this.oldGroupProjectVoList[val]);
          this.sortEndTimeList(arr);
          this.newGroupProjectVoList[val] = this.deepClone(arr);
          this.groupProjectVoList[val].dataList = arr.dataList;
          console.log("3");
        };
      } else {//取存储的新值进行正序
        this.thisEndIndex = null;
        let newData = this.deepClone(this.newGroupProjectVoList[val]);
        this.groupProjectVoList[val].dataList = newData.dataList.reverse();
        console.log("4");
      };
    },
    sortEndTimeList(list) {//按结束时间冒泡排序
      let dataList = list.dataList;

      const len = dataList.length;
      if (len < 2) return dataList;
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < i; j++) {
          if (dataList[j].schEndDate.replace(/[^0-9]/ig, "") < dataList[i].schEndDate.replace(/[^0-9]/ig, "")) {
            const temp = dataList[j]
            dataList[j] = dataList[i]
            dataList[i] = temp;
          };
        };
      };
      return list;
    },
    multipleLoadTable(val, arr) {
      if (arr == 1) {
        this.projectStatusType = this.searchValue.searchMapVo.projectStatusTypes.length == 0 && val.length !== 0 ? true : false;
      };
      if (arr == 2) {
        let selectList = this.deepClone(this.oldSelect2list);
        if (val.length == 0) {
          this.select2list = selectList;
        } else {
          console.log(selectList);
          let arr = [];
          val.map(item => {
            selectList.map(item2 => {
              if (item2.type == item) {
                arr.push(item2);
              };
            })
          });
          console.log(arr);
          this.select2list = arr;
        };
      };

      for (let i = 0; i < val.length; i++) {
        if (val[i] == "cancleAll") {
          switch (arr) {
            case 0:
              this.searchValue.searchMapVo.rootProjectIds = [];
              break;
            case 1:
              this.searchValue.searchMapVo.projectStatusIds = [];
              this.projectStatusType = false;
              break;
            case 2:
              this.searchValue.searchMapVo.projectStatusTypes = [];
              this.select2list = this.deepClone(this.oldSelect2list);
              break;
            case 3:
              this.searchValue.searchMapVo.principalIds = [];
              break
            case 6:
              this.searchValue.searchMapVo.projectManagerIds = [];
              break;
            case 7:
              this.searchValue.searchMapVo.executorIds = [];
              break;
            case 8:
              this.searchValue.searchMapVo.observerIds = [];
              break;
          }
        };
      };
      this.loadTable();
    },
    moreListsClick(command) {
      console.log(command);
      this.navListNum = -1;
      this.radioType = true;
      this.status = command;
      this.searchValue.searchMapVo = { //清空搜索条件
        overdueTypeId: "",
        rootProjectIds: [],
        userIds: [],
        projectStatusIds: [],
        projectStatusTypes: [],
        val: ""
      };
      this.navListNum = 6;
      this.searchValue.subClassId = command;
      this.loadSearchValue(command);
      this.loadTable();
    },
    typeClick() {
      this.listsShow = false;
      if (this.radio1 == this.$t('message.button.list')) {
        this.searchValue.searchType = 1;
      } else if (this.radio1 == this.$t('message.button.state')) {
        this.searchValue.searchType = 2;
      } else if (this.radio1 == this.$t('message.button.type')) {
        this.searchValue.searchType = 3;
      } else if (this.radio1 == this.$t('message.button.members')) {
        this.searchValue.searchType = 4;
      };
      this.loadTable();
    },
    navClick(i) {
      this.navListNum = i;
      console.log(i);
      if (i == 0) {
        this.radioType = false;
      } else {
        this.radioType = true;
      };
      console.log(this.subClsLists[i]);
      this.searchValue.searchMapVo = { //清空搜索条件
        overdueTypeId: "",
        rootProjectIds: [],
        userIds: [],
        projectStatusIds: [],
        projectStatusTypes: [],
        val: ""
      };
      this.searchValue.subClassId = this.subClsLists[i].value;
      this.loadSearchValue(this.subClsLists[i].value);
      this.loadTable();
    },
    loadTab() {
      var vm = this;
      axios.get("/ppm/projectBoard/loadMyTasksSubclass").then(function (res) {
        var dataTab = res.data.object.subClsesList;//取subCls
        vm.subClsLists = [{ name: "所有", value: 0, }];
        if (dataTab.length < 6) {
          vm.headerTabMoreBtn = false;
          for (var i = 0; i < dataTab.length; i++) {
            var obj = {};
            obj.name = dataTab[i].name;
            obj.value = dataTab[i].id;
            vm.subClsLists.push(obj);
          };
        } else {
          vm.headerTabMoreBtn = true;
          for (var i = 0; i < dataTab.length; i++) {
            var obj = {};
            obj.name = dataTab[i].name;
            obj.value = dataTab[i].id;
            if (i < 5) {
              vm.subClsLists.push(obj);
            } else {
              vm.headerMoreLists.push(obj);
            };
          };
        };
      })
    },
    loadSearchValue(typeVal) {
      var vm = this;
      var searchVal = { subClassId: "" };
      if (typeVal) {
        searchVal.subClassId = typeVal;
        searchVal.searchType = this.searchValue.searchType;
      };
      this.select1list = [];
      this.select2list = [];
      this.select3list = [];
      this.select4list = [];
      this.select5list = [];
      this.select6list = [];
      this.select7list = [];
      this.select8list = [];
      axios.post("/ppm/projectBoard/loadMyTaskSearchMapVo", searchVal).then(function (res) {
        console.log(res);
        var searchMap = res.data.object.searchMapVo;

        const list = ["principalList", "observerUserList", "executorList", "pmuserList"];

        // console.log(arr);
        const getUserList = (arr) => {
          if (!arr.length) {
            return []
          }
          return arr.map(j => ({ value: j.id, label: j.loginId + j.userName }));
        }

        let volists = searchMap.overdueTypeVoList.map(item => {//逾期类型列表
          return {
            value: item.id,
            label: item.name,
          }
        });
        vm.select4list = volists;

        let projectList = searchMap.rootProjectList.map(item => {//项目列表
          return {
            value: item.id,
            label: item.name,
          }
        });
        vm.select1list = projectList;

        let userList = {};

        for (const key in searchMap) {
          if (list.includes(key)) {
            userList[key] = getUserList(searchMap[key])
          }
        }
        // [ "principalList", "observerUserList",  "executorList",  "pmuserList"];
        vm.select3list = userList.principalList;//负责人列表
        vm.select6list = userList.pmuserList;//项目经理列表
        vm.select7list = userList.executorList;//执行者列表
        vm.select8list = userList.observerUserList;//观察者列表

        // vm.select3list = userList[0];//负责人列表
        // vm.select6list = userList[2];//项目经理列表
        // vm.select7list = userList[1];//执行者列表
        // vm.select8list = userList[3];//观察者列表

        let projectStatusList = searchMap.projectStatusList.map(item => {//状态列表
          return {
            value: item.id,
            label: item.name,
            type: item.statusType
          }
        });
        vm.select2list = projectStatusList;
        vm.oldSelect2list = vm.deepClone(projectStatusList);

        let projectStatusTypeVoList = searchMap.projectStatusTypeVoList.map(item => {//状态列表
          return {
            value: item.statusType,
            label: item.name,
          }
        });
        vm.select5list = projectStatusTypeVoList;

        vm.tipMap = searchMap.tipMap;
      })
    },
    loadTable() {
      var tabInfo = this.searchValue;
      console.log(tabInfo);
      var vm = this;
      this.taskLoading = true;
      axios.post("/ppm/projectBoard/loadMyTasks", tabInfo).then(function (res) {
        console.log(res);
        if (res.data.code == 200) {
          vm.taskLoading = false;

          vm.gridOptions.data = res.data.object.projectList;
          vm.groupProjectVoList = res.data.object.groupProjectVoList;
          if (vm.groupProjectVoList) {
            //console.log(vm.groupProjectVoList);
            vm.groupProjectVoList.map(i => {
              i.isClick = i.statusType == 1 ? 1 : 0;
              i.dataList.map(j => {
                const date = Date.parse(new Date());
                j.rateDate = Math.floor((Date.parse(j.schEndDate) - date) / (24 * 60 * 60 * 1000));
                j.schEndDate = j.schEndDate.split('T')[0];
                //console.log(j.rateDate);
              })
            })
          };
          vm.oldGroupProjectVoList = vm.groupProjectVoList ? vm.deepClone(vm.groupProjectVoList) : "";

          if (tabInfo.searchType == 1) {
            vm.listsShow = true;
          } else {
            vm.listsShow = false;
          };

        }
      });
    },
    table2RowClick(index, index2) {
      //console.log(index,index2);
      var obj = {
        row: this.groupProjectVoList[index].dataList[index2]
      };
      this.rowClick(obj);
    },
    rowClick(row) {
      let row_ = row.row;
      this.getLink(row_);

    },
  },

  mounted() {
  },
  activated() {
    this.loadTable();
    this.loadSearchValue();
  },

  created() {
    this.loadTab();
    this.loadSearchValue();
    this.loadTable();
    // this.$store.commit('setIncludesList', 'myAgent')
  }
}
</script>

<style>
.el-select-dropdown__item {
  max-width: 800px;
}
</style>

<style scope>
.red {
  border: 1px solid #F56C6C;
  color: #F56C6C;
}

.green {
  border: 1px solid #13ce66;
  color: #13ce66;
}

.table-rate {

  padding: 0 10px;
  line-height: 18px;
  border-radius: 2px;
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  margin: 10px 10px;
  margin-right: 0;
  border: #fcad2c 1px solid;
  color: #fcad2c;
  /* font-size: 10px; */
}

.selected {
  color: #66b1ff;
  background: #ecf5ff;
}

.option-cancel {
  border-bottom: 1px solid #cecece;
}

#departments {
  height: 100%;
}

.task {
  overflow: auto;
  /* height: 100%; */
  /* height: 1300px; */
  background: #fff;
  display: flex;
}

.task-left {
  height: 100%;
  width: 100%;
  flex: 1;
}

.task-header {
  border-bottom: 1px solid #dadee3;
  height: 42px;
  width: 98%;
  float: left;
  margin: 0 1%;
  overflow: hidden;
}

.task-header-left {
  width: 60%;
  height: 42px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  float: left;
}

.task-header-left li {
  width: 14%;
  height: 40px;
  float: left;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.taskHeaderNavClick {
  border-bottom: 2px solid #2c7ef8;
}

.el-dropdown-link {
  color: #000;
  font-size: 16px;
}

.task-header-right {
  width: 40%;
  height: 40px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  float: right;
}

.task-header-right-radio {
  float: right;
  margin-top: 5px;
}

.task-content-select {
  margin-top: 10px;
}

.task-content-select1 {
  margin-right: 10px;
}

.task-content-select1 .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task-content-select1 .el-select .el-tag__close.el-icon-close {
  top: -7px;
}

.task-content {
  float: left;
  width: 98%;
  height: 90%;
  margin: 0 1%;
}

.task-content-table {
  margin-top: 10px;
}

.task-right {
  width: 248px;
  height: 100%;
  background: #f5f6f8;
  float: right;
  overflow: hidden;
}

.task-content-table2 {
  /* height: 89%; */
  height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: hidden;
}

.table2Lists {
  width: 100%;
  height: calc(100vh - 280px);
  /* height: 95%; */
  margin: 10px 0;
  padding: 0;
  overflow-x: auto;
  white-space: nowrap;
}

.table2Lists::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.table2Lists::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #cecece;
}

.table2Lists::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #EDEDED;
}

.table2Lists li:nth-child(1) {
  margin-left: 0;
}

.table2Lists li {
  min-width: 20rem;
  max-width: 24rem;
  height: 98%;
  margin-left: 10px;
  background: #f5f6f8;
  display: inline-flex;
  flex-direction: column;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-sizing: border-box;
  vertical-align: top;
}

.table2List-header {
  flex: none;
  border-bottom: 1px solid #dcdcdc;
}

.table2List-header-inner {
  padding: .25rem .5rem;
  height: 32px;
  background: rgba(140, 255, 164, 0.04);
  line-height: 32px;
}

.table2List-header-inner-name {
  font-size: 14px;
  margin-left: 6px;
  font-weight: 700;
}

.table2List-header-inner-time {
  font-size: 14px;
  float: right;
  cursor: pointer;
}

.table2List-header-inner-time1 {
  font-size: 14px;
  margin-left: 6px;
  margin-right: 10px;
  float: right;
  cursor: pointer;
}

.sort-click {
  color: #409EFF;
}

.table2List-header-inner-number {
  font-size: 14px;
  float: right;
  color: #909aaa;
  font-weight: 200;
}

.table2List-body {
  flex: auto;
  min-height: 0;
  background: #f5f6f8;
  padding: .5rem;
  overflow-y: auto;
  transform: translateZ(0);
}

.table2List-body::-webkit-scrollbar {
  width: 10px;
}

.table2List-body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #cecece;
}

.table2List-body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #EDEDED;
}

.table2List-body-card {

  /* border-bottom: 1px solid #dcdcdc; */
  padding: 16px;
  border-radius: 3px;
  margin: 0 0 .5rem;
  background: #fff;
  position: relative;
  white-space: normal;
  word-break: break-all;
  border: #fff 4px solid;
  border-left: 4px solid rgb(140, 146, 164);
  cursor: pointer;
}

.table2List-body-card:hover {
  /* border-left: 3px solid rgb(135, 206, 250);
    border-right: 3px solid rgb(135, 206, 250);
    border-bottom: 3px solid rgb(135, 206, 250);
    border-top:  3px solid rgb(135, 206, 250); */
  border: 4px solid #409EFF;
  padding: 16px;
  border-radius: 3px;
  margin: 0 0 .5rem;
  background: #ffffff;
  position: relative;
  white-space: normal;
  word-break: break-all;
}

.isOverdue {
  border-left: 4px solid #F56C6C;
}

.isOver {
  border-left: 4px solid #13ce66;
}

.isRate {
  border-left: 4px solid #fcad2c;
}

.table2List-body-card-name {
  font-size: 14px;
  cursor: pointer;
}

.table2List-body-card-name:hover {
  color: #2c7ef8;
  text-decoration: underline;
}

.table2List-body-card-type-subCls {
  padding: 0 10px;
  line-height: 18px;
  background-color: rgb(119, 163, 228);
  color: #fff;
  border: 0px;
  border-radius: 3px;
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  margin: 10px 0;
}

.table2List-body-card-type-schOverdueTime {
  padding: 0 10px;
  line-height: 18px;
  /* border: 1px solid #de350b;
    color: #de350b; */
  border-radius: 2px;
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  margin: 10px 10px;
  margin-right: 0;
}

.table2List-body-card-type-schOverdueTime-over {
  padding: 0 10px;
  line-height: 18px;
  border: 1px solid #13ce66;
  color: #13ce66;
  border-radius: 2px;
  display: inline-block;
  white-space: nowrap;
  font-size: 12px;
  margin: 10px 10px;
}

.table2List-body-card-date-time {
  color: #909aaa;
  font-size: 14px;
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table2List-body-card-date-user {
  color: rgb(121, 187, 255);
  font-size: 14px;
  width: 100%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
